var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormBody',{attrs:{"mode":_vm.mode},on:{"submit-success":_vm.handleSubmitSuccess,"cancel":_vm.handleCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }